export const brandStoryPage = {
  hero: {
    tag: "品牌故事",
    title: "從一顆紅豆餅開始，綉出日常裡的甜",
    subtitle:
      "來加綉綉相信，真正讓人記得的點心，不只是味道，而是那一刻被香氣、溫度與人情味接住的感覺。",
  },
  origin: {
    sectionTitle: "我們想做的，不只是紅豆餅",
    body: "紅豆餅是很多人從小到大的共同記憶。放學路上的小攤、下班後的一顆熱點心、家人一起分著吃的甜味，這些看似簡單的畫面，都是來加綉綉想保留下來的品牌溫度。",
  },
  philosophy: {
    sectionTitle: "把簡單的點心，做到穩定、好吃、有記憶點",
    items: [
      {
        title: "食材安心",
        desc: "重視餅皮、內餡與製程穩定，讓顧客吃得到安心與熟悉。",
      },
      {
        title: "手作溫度",
        desc: "每一顆紅豆餅都承載現烤香氣與職人的細節。",
      },
      {
        title: "品牌陪伴",
        desc: "希望成為顧客日常裡想起甜點時，第一個想到的名字。",
      },
    ],
  },
  spirit: {
    sectionTitle: "來加，是歡迎；綉綉，是把日子綉得更甜",
    body: "「來加綉綉」像是一句親切招呼，也像一份邀請。邀請你停下來，買一顆剛出爐的紅豆餅，把今天過得更有味道一點。",
  },
  cta: {
    title: "想更認識我們的產品嗎？",
    primary: "查看產品介紹",
    secondary: "聯絡我們",
  },
};